import React from 'react';
import { motion } from 'framer-motion';
export function Introduction() {
  return <section className="py-24 md:py-32 bg-white px-6" data-id="element-261">
      <div className="max-w-4xl mx-auto text-center" data-id="element-262">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="flex flex-col items-center" data-id="element-263">
          <div className="w-px h-16 bg-gold mb-8" data-id="element-264"></div>

          <h2 className="text-3xl md:text-5xl font-serif text-charcoal mb-8 leading-tight" data-id="element-265">
            Elevating the Standard of <br data-id="element-266" />
            <span className="italic text-gold" data-id="element-267">Luxury Real Estate</span>
          </h2>

          <p className="text-lg md:text-xl text-charcoal-light font-light leading-relaxed max-w-3xl" data-id="element-268">
            As Las Vegas's premier luxury real estate destination, we specialize
            in curating an exclusive portfolio of the city's most magnificent
            properties. From sprawling desert estates to sophisticated high-rise
            penthouses, we provide an unparalleled level of service and
            discretion for our discerning clientele.
          </p>

          <div className="w-px h-16 bg-gold mt-12" data-id="element-269"></div>
        </motion.div>
      </div>
    </section>;
}